module.exports = __webpack_public_path__ + "img/solarPanels_online.3289df96.png";